'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */
var isNumericalString = function (v) {
  return /^\-?\d*\.?\d+$/.test(v);
};

exports.isNumericalString = isNumericalString;
